import type { Timer } from '@/shared/lib/hooks/useTimer';
import useTimer from '@/shared/lib/hooks/useTimer';
import { RpmMonitoringActivityTypes } from '@/shared/lib/types/remotePatientMonitoring';
import create from 'zustand';

type TimerStore = {
  activeTimer: Timer | undefined;
  setActiveTimer: (timer: Timer | undefined) => void;
  activeType: RpmMonitoringActivityTypes | undefined;
  setActiveType: (val: RpmMonitoringActivityTypes | undefined) => void;
  isReadOnly: boolean;
  setIsReadOnly: (val: boolean) => void;

  stopMedTaskTrackingFn: (() => Promise<void>) | null;
  setStopMedTaskTrackingFn: (fn: (() => Promise<void>) | null) => void;
};

const useStore = create<TimerStore>(set => ({
  activeTimer: undefined,
  setActiveTimer: timer => set({ activeTimer: timer }),
  activeType: undefined,
  setActiveType: type => set({ activeType: type }),
  isReadOnly: false,
  setIsReadOnly: val => set({ isReadOnly: val }),
  stopMedTaskTrackingFn: null,
  setStopMedTaskTrackingFn: fn => set({ stopMedTaskTrackingFn: fn })
}));

export const useRpmWorkflowStore = () => {
  const careActivityTimer = useTimer(RpmMonitoringActivityTypes.CareActivity, 'Care Activity');
  const encounterTimer = useTimer(RpmMonitoringActivityTypes.Encounter, 'Encounter');
  const {
    activeTimer,
    setActiveTimer,
    activeType,
    setActiveType,
    setIsReadOnly,
    isReadOnly,
    stopMedTaskTrackingFn,
    setStopMedTaskTrackingFn
  } = useStore();

  return {
    careActivityTimer,
    encounterTimer,
    activeTimer,
    setActiveTimer,
    activeType,
    setActiveType,
    setIsReadOnly,
    isReadOnly,
    stopMedTaskTrackingFn,
    setStopMedTaskTrackingFn
  };
};
